import React from 'react'
import { Layers } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { colecoesApi } from '../../api/tabelasBasicas'

const ColecoesPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Coleções"
      breadcrumb="Tabelas › Básicas"
      icon={<Layers size={17} />}
      cdMaxLen={2}
      nmMaxLen={30}
      api={colecoesApi}
    />
  )
}

export default ColecoesPage
